import { h, defineComponent, VNode } from 'vue';
import { UserQuota } from '@/entities/auth/loggedInUser';
import CircularLoader from '@/_legacy/components/Icons/CircularLoader.vue';
import { calculateQuotaRate, user } from '@/ui/auth/auth';
import { t, toUnixTimestamp } from '@/ui/i18n/i18n';
import { MILLISECONDS } from '@/_legacy/constants';

interface QuotaInfoProps {
  userQuota: UserQuota;
}

export const QuotaInfo = defineComponent<QuotaInfoProps>({
  name: 'QuotaInfo',
  props: ['userQuota'],
  setup(props, context) {
    const getResetsIn = (resetDate: number) => {
      let unit = 'days';
      const today = new Date();
      const now = Date.UTC(
        today.getFullYear(),
        today.getMonth(),
        today.getDate(),
        today.getHours(),
      );
      const diff = resetDate * 1000 - now;

      let resetsIn = Math.floor(diff / MILLISECONDS.MS_PER_DAY);

      if (!resetsIn) {
        resetsIn = Math.ceil(diff / MILLISECONDS.MS_PER_HOUR);
        unit = 'hours';
      }

      return {
        time: resetsIn,
        unit,
      };
    };

    const resetsIn = () => {
      let termEnd = null;

      if (user.value.subscription) {
        termEnd = user.value.subscription.currentTermEnd;
      }

      if (user.value.organization.subscription) {
        termEnd = user.value.organization.subscription.currentPeriodEnd;
      }

      return termEnd
        ? getResetsIn(toUnixTimestamp(termEnd.getTime()))
        : {
          time: 0,
          unit: '',
        };
    };

    return function render(): VNode {
      return h('div', { class: 'quota-info right flex flex-row items-center mx-3 leading-none' },
        [
          h(CircularLoader, {
            class: 'mr-2',
            props: {
              height: 36,
              percentage: calculateQuotaRate(props.userQuota),
            },
          }),
          h('span', { class: 'flex flex-col my-auto mx-0' },
            [
              h('span', { class: 'font-semibold' }, t('navbar.status-inspections', {
                current: props.userQuota.current.toString(),
                max: props.userQuota.max.toString(),
              })),
              user.value.organization.subscription
                ? h('span', {}, t('navbar.reset-time', {
                  time: resetsIn().time.toString(),
                  unit: resetsIn().unit.toString(),
                }))
                : null,
            ]),
          context.slots.afterText?.(),
        ]);
    };
  },
});
